import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Table,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { isEmpty } from "lodash";

//Import Star Ratings
import StarRatings from "react-star-ratings";

//Import Product Images
import { productImages } from "assets/images/product";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

//Import actions
import {
  getProductDetail as onGetProductDetail,
  getProductComments,
  onAddReply as onAddReplyAction,
  onAddComment as onAddCommentAction,
} from "store/actions";
import RecentProducts from "./RecentProducts";
import Reviews from "./Reviews";

//redux
import { useSelector, useDispatch } from "react-redux";

const EcommerceProductDetail = props => {

  //meta title
  document.title = "Property Details | Aiinrealestate";

  const dispatch = useDispatch();

  const { product, productComments } = useSelector(state => ({
    product: state.ecommerce.product,
    productComments: state.ecommerce.productComments,
  }));

  const [activeTab, setActiveTab] = useState("1");

  const params = props.router.params;

  useEffect(() => {
    if (params && params.id) {
      dispatch(onGetProductDetail(params.id));
    } else {
      dispatch(onGetProductDetail(1));
    }
  }, [dispatch]);

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const imageShow = (img, id) => {
    const expandImg = document.getElementById("expandedImg" + id);
    expandImg.src = img;
  };

  useEffect(() => {
    dispatch(getProductComments());
  }, [dispatch]);

  const [comments, setComments] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");

  useEffect(() => {
    if (productComments) {
      setComments(productComments);
    }
  }, [productComments]);

  const onClickReply = commentId => {
    const modifiedComments = [...comments];

    const commentIdx = (modifiedComments || []).findIndex(
      comment => comment.commentId.toString() === commentId.toString()
    );
    if (commentIdx > -1) {
      if (modifiedComments[commentIdx]) {
        modifiedComments[commentIdx]["showAddComment"] = true;

        for (let i = 0; i < (modifiedComments || []).length; i++) {
          if (i !== commentIdx) {
            modifiedComments[i]["showAddComment"] = false;
          }
        }
      } else {
        modifiedComments[commentIdx]["showAddComment"] = false;
      }
      setComments(modifiedComments);
    }
  };

  const onCancelReply = commentId => {
    if (commentId) {
      const modifiedComments = [...comments];
      for (let i = 0; i < (modifiedComments || []).length; i++) {
        modifiedComments[i]["showAddComment"] = false;
      }
      setComments(modifiedComments);
    }
  };

  const onAddReply = (commentId, replyText) => {
    if (commentId) {
      const productId = params.id || 1;
      dispatch(onAddReplyAction(commentId, productId, replyText));
    }
  };

  const onAddComment = commentText => {
    const productId = params.id || 1;
    dispatch(onAddCommentAction(productId, commentText));
  };


  const cardStyle = {
    background: "rgba(255, 255, 255, 0.1)",
    border: "none",
    borderRadius: "15px",
  };


  // Show Modal
  const openImageModal = (image) => {
    setModalImage(image);
    setIsModalOpen(true);
  };

  // Close Modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <Breadcrumbs title="Ecommerce" breadcrumbItem="Product Detail" /> */}
          {!isEmpty(product) && (
            <Row>
              <Col>
                <Card style={cardStyle}>
                  <CardBody style={{ backgroundColor: '#1E253A', borderRadius: '10px', padding: '20px', boxShadow: '0 4px 10px rgba(0,0,0,0.3)' }}>
                    <Row>
                      <Col xl={6}>
                        <div className="product-detai-imgs">
                          <Row>
                            <Col md={2} sm={3} className="col-4">
                              <Nav className="flex-column" pills>
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active: activeTab === "1",
                                    })}
                                    onClick={() => {
                                      toggleTab("1");
                                    }}
                                    style={{
                                      borderRadius: '5px',
                                      backgroundColor: '#3C154F',
                                      padding: '5px',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    <img
                                      src={product["subImage"][0]}
                                      alt=""
                                      onClick={() => {
                                        imageShow(product["subImage"][0], 1);
                                      }}
                                      className="img-fluid mx-auto d-block rounded"
                                    />
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active: activeTab === "2",
                                    })}
                                    onClick={() => {
                                      toggleTab("2");
                                    }}
                                    style={{
                                      borderRadius: '5px',
                                      backgroundColor: '#3C154F',
                                      padding: '5px',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    <img
                                      src={product["subImage"][1]}
                                      alt=""
                                      onClick={() => {
                                        imageShow(product["subImage"][1], 2);
                                      }}
                                      className="img-fluid mx-auto d-block rounded"
                                    />
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active: activeTab === "3",
                                    })}
                                    onClick={() => {
                                      toggleTab("3");
                                    }}
                                    style={{
                                      borderRadius: '5px',
                                      backgroundColor: '#3C154F',
                                      padding: '5px',
                                    }}
                                  >
                                    <img
                                      src={product["subImage"][2]}
                                      alt=""
                                      onClick={() => {
                                        imageShow(product["subImage"][2], 3);
                                      }}
                                      className="img-fluid mx-auto d-block rounded"
                                    />
                                  </NavLink>
                                </NavItem>
                              </Nav>
                            </Col>
                            <Col md={7} sm={9} className="offset-md-1 col-8">
                              <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                  <div>
                                    <img
                                      src={productImages[product.image]}
                                      alt=""
                                      id="expandedImg1"
                                      className="img-fluid mx-auto d-block"
                                      onClick={() => openImageModal(productImages[product.image])}
                                      style={{
                                        borderRadius: "10px",
                                        boxShadow: "0 10px 15px rgba(0, 0, 0, 0.2)",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                </TabPane>
                                <TabPane tabId="2">
                                  <div>
                                    <img
                                      src={productImages[product.image]}
                                      id="expandedImg2"
                                      alt=""
                                      onClick={() => openImageModal(productImages[product.image])}
                                      className="img-fluid mx-auto d-block"
                                      style={{
                                        borderRadius: "10px",
                                        boxShadow: "0 10px 15px rgba(0, 0, 0, 0.2)",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                </TabPane>
                                <TabPane tabId="3">
                                  <div>
                                    <img
                                      src={productImages[product.image]}
                                      id="expandedImg3"
                                      alt=""
                                      onClick={() => openImageModal(productImages[product.image])}
                                      className="img-fluid mx-auto d-block"
                                      style={{
                                        borderRadius: "10px",
                                        boxShadow: "0 10px 15px rgba(0, 0, 0, 0.2)",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                </TabPane>
                              </TabContent>
                            </Col>
                          </Row>
                          {/* Full-Image Modal */}
                          <Modal isOpen={isModalOpen} toggle={closeModal} centered>
                            <ModalHeader toggle={closeModal} style={{ borderBottom: "none" }} />
                            <ModalBody>
                              <img
                                src={modalImage}
                                alt="Full View"
                                className="img-fluid mx-auto d-block"
                                style={{ borderRadius: "2px" }}
                              />
                            </ModalBody>
                          </Modal>
                        </div>
                      </Col>

                      <Col xl={6}>
                        <div className="mt-4 mt-xl-3" style={{ color: '#F1F1F1' }}>
                          <Link to="#" className="text-primary" style={{ fontWeight: 'bold' }}>
                            Krishna Bhuvi Villas, Bhayli
                          </Link>
                          <h4 className="mt-1 mb-3 text-light" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                            Krishna Bhuvi, 4BHK and 5BHK Villas
                          </h4>

                          {/* Ratings and Reviews */}
                          <div className="text-muted float-start me-3">
                            <StarRatings
                              rating={4}
                              starRatedColor="#F1B44C"
                              starEmptyColor="#74788d"
                              numberOfStars={5}
                              name="rating"
                              starDimension="14px"
                              starSpacing="3px"
                            />
                          </div>
                          <p className="text-muted mb-4">( 150+ Customers Review )</p>

                          {/* Price Section */}
                          <Row>
                            {/* 4BHK Villa Card */}
                            <Col xl={6}>
                              <div style={{
                                backgroundColor: '#34495E',
                                borderRadius: '8px',
                                padding: '15px',
                                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                                marginBottom: '15px',
                              }}>
                                <h4 className="text-light" style={{
                                  fontSize: '1.3rem',
                                  fontWeight: 'bold',
                                  color: '#ECF0F1'
                                }}>4 BHK Villa</h4>
                                <p className="text-muted" style={{
                                  fontSize: '0.9rem',
                                  color: '#BDC3C7'
                                }}>Built-up Area: 3100 sq.ft. (288.0 sq.m.)</p>
                                <h5 className="text-light" style={{
                                  fontSize: '1.2rem',
                                  fontWeight: 'bold',
                                  color: '#F39C12'
                                }}>₹2.4 Cr</h5>
                              </div>
                            </Col>

                            {/* 5BHK Villa Card */}
                            <Col xl={6}>
                              <div style={{
                                backgroundColor: '#34495E',
                                borderRadius: '8px',
                                padding: '15px',
                                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                                marginBottom: '15px',
                              }}>
                                <h4 className="text-light" style={{
                                  fontSize: '1.3rem',
                                  fontWeight: 'bold',
                                  color: '#ECF0F1'
                                }}>5 BHK Villa with Entertainment Room</h4>
                                <p className="text-muted" style={{
                                  fontSize: '0.9rem',
                                  color: '#BDC3C7'
                                }}>Built-up Area: 4114 sq.ft. (382.2 sq.m.)</p>
                                <h5 className="text-light" style={{
                                  fontSize: '1.2rem',
                                  fontWeight: 'bold',
                                  color: '#F39C12'
                                }}>₹3.2 Cr</h5>
                              </div>
                            </Col>
                          </Row>

                          {/* Property Description */}
                          <div style={{
                            backgroundColor: '#2C3E50',
                            borderRadius: '8px',
                            padding: '20px',
                            marginBottom: '20px',
                          }}>
                            <p className="text-muted" style={{
                              fontSize: '1rem',
                              color: '#D3D3D3',
                              lineHeight: '1.5',
                            }}>
                              Krishna Bhuvi offers a blend of comfort and luxury. Spread over 1.2 acres, this society provides 4BHK and 5BHK villas that are ready to move in, making it the ideal place for families.
                            </p>
                          </div>


                          {/* Property Features */}
                          <div style={{
                            backgroundColor: '#2C3E50',
                            borderRadius: '8px',
                            padding: '15px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            marginBottom: '20px'
                          }}>
                            <h5 style={{
                              color: '#ECF0F1',
                              fontWeight: 'bold',
                              marginBottom: '15px',
                              fontSize: '1.2rem',
                              textTransform: 'uppercase',
                              letterSpacing: '1px',
                            }}>Property Features</h5>

                            <Row>
                              <Col md="6">
                                <div style={{
                                  backgroundColor: '#34495E',
                                  borderRadius: '8px',
                                  padding: '15px',
                                  marginBottom: '15px',
                                }}>
                                  <p style={{
                                    fontSize: '1rem',
                                    color: '#ECF0F1',
                                    marginBottom: '8px',
                                  }}><strong>Configuration:</strong> 4BHK / 5BHK Villas</p>
                                  <p style={{
                                    fontSize: '1rem',
                                    color: '#ECF0F1',
                                    marginBottom: '8px',
                                  }}><strong>Size:</strong> 3,100 sq.ft. / 4,114 sq.ft.</p>
                                  <p style={{
                                    fontSize: '1rem',
                                    color: '#ECF0F1',
                                    marginBottom: '8px',
                                  }}><strong>Price:</strong> ₹ 2.3 Cr. To ₹ 3.2 Cr</p>
                                </div>
                              </Col>
                              <Col md="6">
                                <div style={{
                                  backgroundColor: '#34495E',
                                  borderRadius: '8px',
                                  padding: '15px',
                                  marginBottom: '15px',
                                }}>
                                  <p style={{
                                    fontSize: '1rem',
                                    color: '#ECF0F1',
                                    marginBottom: '8px',
                                  }}><strong>Location:</strong> Bhayli, Vadodara</p>
                                  <p style={{
                                    fontSize: '1rem',
                                    color: '#ECF0F1',
                                    marginBottom: '8px',
                                  }}><strong>Ready to Move</strong></p>
                                  <p style={{
                                    fontSize: '1rem',
                                    color: '#ECF0F1',
                                    marginBottom: '8px',
                                  }}><strong>High-Quality Finish & Architecture</strong></p>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {/* Top Facilities Section */}
                    <div className="mt-5">
                      <h5 className="mb-3" style={{
                        color: '#F1F1F1',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                      }}>Top Facilities in this project:</h5>
                      <Row>
                        <Col md={6}>
                          <ul style={{ color: '#D3D3D3' }}>
                            <li>Park</li>
                            {/* <li>Fountain</li> */}
                            <li>Senior Citizen Sitout</li>
                            <li>Car Parking</li>
                            <li>Gated Community</li>
                          </ul>
                        </Col>
                        <Col md={6}>
                          <ul style={{ color: '#D3D3D3' }}>
                            <li>Internal Street Lights</li>
                            <li>CCTV Camera Security</li>
                            <li>Security Cabin</li>
                            <li>Cleanliness</li>
                          </ul>
                        </Col>
                      </Row>
                    </div>

                    {/* Other Facilities Section */}
                    <div className="mt-4">
                      <h5 className="mb-3" style={{
                        color: '#F1F1F1',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                      }}>Other Facilities:</h5>
                      <ul style={{ color: '#D3D3D3' }}>
                        <li>Common for all ION Exchange water softening plant</li>
                        <li>Lift to all Villas</li>
                      </ul>
                    </div>

                    {/* Specifications Section */}
                    <div className="mt-5">
                      <h5 className="mb-3" style={{
                        color: '#F1F1F1',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                      }}>Specifications:</h5>
                      <div className="table-responsive">
                        <table className="table table-bordered" style={{
                          backgroundColor: '#34495E',
                          color: '#D3D3D3',
                          borderRadius: '8px',
                        }}>
                          <thead>
                            <tr>
                              <th style={{ color: '#F1F1F1', fontWeight: 'bold' }}>Category</th>
                              <th style={{ color: '#F1F1F1', fontWeight: 'bold' }}>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Structure</td>
                              <td>RCC Framed Structure</td>
                            </tr>
                            <tr>
                              <td>Flooring</td>
                              <td>Vitrified Tiles</td>
                            </tr>
                            <tr>
                              <td>Doors</td>
                              <td>Flush Doors</td>
                            </tr>
                            <tr>
                              <td>Windows</td>
                              <td>UPVC / Powder Coated Aluminium</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </CardBody>
                  <Link
                    to="/dashboard"
                    title="Any Questions or Queries?"
                    style={{
                      position: "fixed",
                      bottom: "20px",
                      right: "20px",
                      backgroundColor: "darkgrey",
                      border: "none",
                      borderRadius: "9999px",
                      padding: "12px",
                      fontSize: "19px",
                      color: "white",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                      transition: "all 0.3s ease",
                      zIndex: 1000,
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.1)";
                      e.target.style.backgroundColor = "#45a049";
                      e.target.style.boxShadow = "0px 6px 18px rgba(0, 0, 0, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1)";
                      e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                      e.target.style.boxShadow = "0px 4px 15px rgba(0, 0, 0, 0.2)";
                    }}
                  >
                    Any Queries &nbsp; <i className="fas fa-question" style={{ margin: 0 }}></i>
                  </Link>

                </Card>
              </Col>
            </Row>
          )}
          {/* <RecentProducts recentProducts={product.recentProducts} /> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

EcommerceProductDetail.propTypes = {
  product: PropTypes.object,
  match: PropTypes.any,
  onGetProductDetail: PropTypes.func,
};

export default withRouter(EcommerceProductDetail);
